// One source for in-app web paths that cross section boundaries (W2/W3 path
// contract, .planning/web-w2w3/cross-check.md F2). Link through these; never
// hand-build "/users/..." or "/chats/..." strings in a page.
import { ConversationService } from "../../../services/conversationService";

export { manageHref } from "../pages/manage/manageUtils";

const seg = (id) => encodeURIComponent(String(id ?? ""));

/** Another user's profile (Profile section owns the route). */
export const userPath = (uid) => `/users/${seg(uid)}`;

export const clubPath = (clubId) => `/clubs/${seg(clubId)}`;

export const eventPath = (eventId) => `/events/${seg(eventId)}`;

export const CHATS_PATH = "/chats";

/** A DM room by conversation id (`dm_<a>_<b>`). */
export const conversationPath = (conversationId) => `${CHATS_PATH}/dm/${seg(conversationId)}`;

/**
 * DM between `me` and `other`. dmIdFor is deterministic, and the room derives
 * the other uid from the id, so no conversation doc has to exist first.
 */
export const dmPath = (me, other) => conversationPath(ConversationService.dmIdFor(me, other));

/**
 * A club's general room, or its E-Board room when `internal`. Keyed by CLUB id:
 * chat ids are not club ids in prod, so the room resolves the chat with ensureClubChat.
 */
export const clubChatPath = (clubId, internal = false) => `${CHATS_PATH}/${internal ? "eboard" : "club"}/${seg(clubId)}`;

export const subChatPath = (subchatId) => `${CHATS_PATH}/sub/${seg(subchatId)}`;
